import React from 'react';
import { Box, Skeleton, CardContent, Card } from '@mui/material';
import { COLOR_PRIMARY_2 } from 'src/utils/colors';

interface AIOverviewCardProps {
  isLoading: boolean;
  isMobileView: boolean;
  children: React.ReactNode;
}

const LoadingSkeleton = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Skeleton variant="rectangular" height={100} sx={{ mb: 1, borderRadius: 2 }} />
      <Skeleton variant="rectangular" height={300} sx={{ mb: 1, borderRadius: 2 }} />
    </Box>
  );
};

const AIOverviewCard = ({ isLoading, isMobileView, children }: AIOverviewCardProps) => {
  if (isLoading) {
    return <LoadingSkeleton />;
  }

  return (
    <Card
      sx={{
        background: '#fff',
        borderRadius: 3,
        boxShadow: '0 2px 12px 0 rgba(16,30,54,.06)',
        border: '1px solid #E0E0E0',
        overflow: 'visible',
        position: 'relative',
        p: 0,
        m: 0,
        minHeight: (isMobileView ? 70 : 100) + 32,
        width: '100%',
        maxWidth: '100vw',
        pb: 0,
        // Top border accent
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '4px',
          background: COLOR_PRIMARY_2,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          zIndex: 2,
        },
      }}
    >
      <CardContent sx={{ p: 2, py: 4, pr: isMobileView ? 2 : 6 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobileView ? 'flex-start' : 'center',
            gap: 2,
            width: '100%',
          }}
        >
          <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>{children}</Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default AIOverviewCard;
